// Talents.tsx
import React from 'react';
import StarRating from '#GameFrontend/unauthorized/components/ui/StarRating';
import { useTranslation } from 'react-i18next';
interface TalentsProps {
	talents: {
		walk: number;
		trot: number;
		canter: number;
		agility: number;
		balance: number;
		speed: number;
		jumping: number;
		stamina: number;
	};
}

const Talents: React.FC<TalentsProps> = ({ talents }) => {
	const { t } = useTranslation();
	return (
		<div className="text-white">
			<div className="flex justify-end">
				<span className="mr-2 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">{t('horse.talent.walk')}</span>{' '}
				<StarRating value={Math.round(talents.walk)} />
			</div>
			<div className="flex justify-end">
				<span className="mr-2 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">{t('horse.talent.trot')}</span>{' '}
				<StarRating value={Math.round(talents.trot)} />
			</div>
			<div className="flex justify-end">
				<span className="mr-2 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">{t('horse.talent.canter')}</span>{' '}
				<StarRating value={Math.round(talents.canter)} />
			</div>
			<div className="flex justify-end">
				<span className="mr-2 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">{t('horse.talent.agility')}</span>{' '}
				<StarRating value={Math.round(talents.agility)} />
			</div>
			<div className="flex justify-end">
				<span className="mr-2 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">{t('horse.talent.balance')}</span>{' '}
				<StarRating value={Math.round(talents.balance)} />
			</div>
			<div className="flex justify-end">
				<span className="mr-2 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">{t('horse.talent.speed')}</span>{' '}
				<StarRating value={Math.round(talents.speed)} />
			</div>
			<div className="flex justify-end">
				<span className="mr-2 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">{t('horse.talent.jumping')}</span>{' '}
				<StarRating value={Math.round(talents.jumping)} />
			</div>
			<div className="flex justify-end">
				<span className="mr-2 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">{t('horse.talent.stamina')}</span>{' '}
				<StarRating value={Math.round(talents.stamina)} />
			</div>
		</div>
	);
};

export type { TalentsProps };
export default Talents;
